module.exports = __webpack_public_path__ + "img/vindico-logo-purple.8fc55459.png";